import { Button, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import Chart from 'react-apexcharts';

const FluctuationChart = ({ data }) => {
  const theme = useTheme()

  const [portfolioChart, setPortfolioChart] = useState([])
  const [series, setSeries] = useState([]);

  const options = {
    chart: {
      id: 'fluctuation-line-chart',
      toolbar: {
        show: false,
      },
      background: 'transparent', // Dark background color
    },
    labels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      theme: "dark"
    },
    colors: series.map(line => line.color),
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 3,
    },
    xaxis: {
      categories: portfolioChart?.map((chart) => chart?.dateUnitPrice),
      labels: {
        show: false,
      },
    },
    yaxis: {
      opposite: true,
      labels: {
        formatter: value => value?.toFixed(2),
        style: {
          colors: theme.palette.text.main, // Y-axis label color
        },
      },
    },
    grid: {
      borderColor: '#34495e', // Grid line color
      strokeDashArray: 3, // Add this to make grid lines dashed
    },
    legend: {
      show: false, // Hide legends
    },
  }

  const toggleSeries = seriesIndex => {
    const updatedSeries = series.map((line, index) => {
      if (index === seriesIndex) {
        return { ...line, show: !line.show };
      }
      return line;
    });

    setSeries(updatedSeries);
  };

  useEffect(() => {

      const chartData = data?.data
      const btcSeries = chartData?.map((chart) => chart?.percentageBTC)
      const goldSeries = chartData?.map((chart) => chart?.percentageGold)
      const mainSeries = chartData?.map((chart) => chart?.percentage)
      const ethSeries = chartData?.map((chart) => chart?.percentageETH)

      setSeries([
        {
          name: 'Main',
          data: mainSeries,
          color: '#3498db',
          show: true
        },
        {
          name: 'BTC',
          data: btcSeries,
          color: '#F7931A',
        },
        {
          name: 'Gold',
          data: goldSeries,
          color: '#f1c40f',
        },
        {
          name: 'ETH',
          data: ethSeries,
          color: '#b8e0fd',
        },
      ])


      setPortfolioChart(chartData)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {series.map((line, index) => (
        <Button
          size="small"
          key={index}
          sx={{ backgroundColor: line.show && line.color, margin: '5px' }}
          onClick={() => toggleSeries(index)}
        >
          {line.name}
        </Button >
      ))}

      <Chart options={options} series={series.filter(line => line.show)} type="area" height={200} />
    </>
  );
};


export default FluctuationChart;